import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomePageComponent } from './modules/home/home-page/home-page.component';
import { PlaceholderForbiddenComponent } from './shared/components/placeholder-forbidden/placeholder-forbidden.component';
import { AuthGuard } from '@auth0/auth0-angular';
import { AuthenticatedGuard } from './shared/guards/authenticated.guard';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule) },
  { path: 'home', canActivate: [AuthGuard, AuthenticatedGuard], loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule), component: HomePageComponent },
  { path: 'forbidden', component: PlaceholderForbiddenComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
